import { Box, HStack, Input } from '@chakra-ui/react';
import { FileIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import React, { ReactElement } from 'react';

type Props = {
  isReviewMode: boolean;
  worksheetTitle: string;
  isTitleEditable: boolean;
  titleInputRef: React.RefObject<HTMLInputElement>;
  onTitleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onTitleClick: (() => void) | undefined;
  onStopTitleEdit: () => void;
  onResetTitle: () => void;
  topButtons: ReactElement;
};

export const WorksheetHeader = ({
  isReviewMode,
  worksheetTitle,
  isTitleEditable,
  titleInputRef,
  onTitleChange,
  onTitleClick,
  onStopTitleEdit,
  onResetTitle,
  topButtons,
}: Props): ReactElement => {
  const handleTitleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      onStopTitleEdit();
    } else if (event.key === 'Escape') {
      onResetTitle();
    }
  };

  const handleTitleBlur = (): void => {
    onStopTitleEdit();
  };

  const getTitleCursor = (): string => {
    if (isTitleEditable) {
      return 'text';
    }
    if (isReviewMode) {
      return 'default';
    }
    return 'pointer';
  };

  return (
    <HStack justifyContent="space-between" alignItems="center" width="100%" maxW="100%">
      <HStack gap="10px" flexShrink={1} width="100%">
        <Box
          boxSize="34px"
          bgColor="tag.background.green"
          display="grid"
          placeItems="center"
          borderRadius="5px"
          //   height="47px"
        >
          <NovaIcon icon={FileIcon} size="l" color="icon.accent" aria-hidden />
        </Box>
        <Input
          readOnly={!isTitleEditable || isReviewMode}
          value={worksheetTitle}
          variant="subtle"
          maxW="400px"
          flexShrink={1}
          textStyle="h2.medium"
          padding="10px 5px"
          onChange={onTitleChange}
          backgroundColor={isTitleEditable ? 'background.canvas' : 'transparent'}
          ref={titleInputRef}
          lineClamp={1}
          overflow="hidden"
          textOverflow="ellipsis"
          cursor={getTitleCursor()}
          onClick={isReviewMode ? undefined : onTitleClick}
          _hover={{
            backgroundColor: !isTitleEditable ? 'background.primary' : undefined,
          }}
          onKeyDown={handleTitleKeyDown}
          onBlur={handleTitleBlur}
        />
      </HStack>
      {topButtons}
    </HStack>
  );
};
